import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { DollarSign, TrendingUp, PieChart, Wallet } from 'lucide-react';

const Finance = () => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundImage: 'url(/dashboard1.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      padding: '2rem',
      color: '#fff',
      position: 'relative'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(10, 10, 30, 0.7)',
        zIndex: 0
      }} />
      
      <div style={{ position: 'relative', zIndex: 1, maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #00ffff, #00ff88)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem',
            fontWeight: 'bold'
          }}>
            Financial Management
          </h1>
          <p style={{ color: '#888', fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto' }}>
            Comprehensive financial planning, investment tracking, and wealth management tools
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem'
        }}>
          <Card style={{
            padding: '1.5rem',
            background: 'rgba(10, 10, 30, 0.1)',
            backdropFilter: 'blur(10px)',
            border: '2px solid rgba(0, 255, 255, 0.5)',
            boxShadow: '0 8px 32px rgba(0, 255, 255, 0.2)'
          }}>
            <DollarSign size={32} style={{ color: '#00ffff', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem', color: '#fff', fontWeight: 'bold', textShadow: '0 0 10px rgba(0,255,255,0.5)' }}>Portfolio Tracking</h3>
            <p style={{ color: '#fff', fontWeight: '500' }}>Monitor investments and asset performance</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(0, 255, 136, 0.1)',
            border: '1px solid rgba(0, 255, 136, 0.3)'
          }}>
            <PieChart size={32} style={{ color: '#00ff88', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Asset Allocation</h3>
            <p style={{ color: '#888' }}>Optimize your investment distribution</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(255, 215, 0, 0.1)',
            border: '1px solid rgba(255, 215, 0, 0.3)'
          }}>
            <Wallet size={32} style={{ color: '#ffd700', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Wealth Planning</h3>
            <p style={{ color: '#888' }}>Long-term financial strategy and planning</p>
          </Card>
        </div>

        <Card style={{
          padding: '2rem',
          background: 'rgba(10, 10, 30, 0.8)',
          border: '1px solid rgba(0, 255, 255, 0.2)',
          marginBottom: '2rem'
        }}>
          <h2 style={{ fontSize: '1.5rem', color: '#00ffff', marginBottom: '1.5rem' }}>Financial Tools</h2>
          <div style={{ color: '#888', lineHeight: '1.8' }}>
            <p>Comprehensive financial management widgets:</p>
            <ul style={{ marginTop: '1rem', paddingLeft: '2rem' }}>
              <li>Portfolio Tracker & Analyzer</li>
              <li>Investment Calculator</li>
              <li>Retirement Planning Tool</li>
              <li>Net Worth Dashboard</li>
              <li>Tax Optimization Assistant</li>
            </ul>
          </div>
        </Card>

        <Card style={{
          padding: '2rem',
          background: 'linear-gradient(135deg, rgba(0,255,255,0.1), rgba(0,255,136,0.1))',
          border: '2px solid #00ffff'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <TrendingUp size={32} style={{ color: '#00ffff' }} />
            <h2 style={{ fontSize: '1.5rem', color: '#00ffff' }}>Financial AI Advisor</h2>
          </div>
          <p style={{ color: '#ccc', marginBottom: '1.5rem' }}>
            Get personalized financial advice from AI financial advisors. Ask about investments, 
            retirement planning, wealth management, or any financial question.
          </p>
          <Button style={{
            background: 'linear-gradient(135deg, #00ffff, #00ff88)',
            color: '#000',
            fontWeight: 'bold',
            padding: '1rem 2rem'
          }}>
            Chat with Financial AI
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default Finance;